import type { Styles } from 'src/theme/themes';

export const styles = {
  header: {
    cursor: 'pointer',
    display: 'flex',
    flexGrow: 0,
    flexShrink: 0,
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  icon: (theme) => ({
    color: theme.colors.neutral[600],
    background: theme.colors.neutral[50],
    width: theme.spacing(3),
    height: theme.spacing(3),
    borderRadius: theme.spacing(0.5),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '&:hover': {
      color: theme.colors.primary[500],
    },
  }),
  iconActive: (theme) => ({
    color: theme.colors.primary[500],
    background: theme.colors.primary[50],
  }),
  selectedFilterCount: (theme) => ({
    fontWeight: '600',
    marginRight: 'auto',
    marginLeft: theme.spacing(1.5),
  }),
  children: (theme) => ({
    marginLeft: 'auto',
    marginRight: theme.spacing(2),
  }),
} satisfies Styles;
